module.exports = __webpack_public_path__ + "img/if_2.418ceaa3.png";